type GraphqlErrorShape = {
  response?: {
    errors?: Array<{
      message?: unknown;
      extensions?: Record<string, unknown>;
    }>;
  };
  code?: unknown;
  extensions?: { code?: unknown };
};

export function getGraphqlErrorCode(error: unknown): string | undefined {
  const err = error as GraphqlErrorShape;
  const code =
    err.response?.errors?.[0]?.extensions?.code ??
    err.code ??
    err.extensions?.code;

  return typeof code === "string" ? code : undefined;
}

export function getGraphqlErrorMessage(error: unknown): string | undefined {
  const message = (error as GraphqlErrorShape).response?.errors?.[0]?.message;
  return typeof message === "string" ? message : undefined;
}

export function getGraphqlErrorNumber(
  error: unknown,
  key: string,
): number | undefined {
  const value = (error as GraphqlErrorShape).response?.errors?.[0]
    ?.extensions?.[key];
  return typeof value === "number" ? value : undefined;
}

export function getErrorMessage(error: unknown, fallback: string): string {
  return error instanceof Error ? error.message : fallback;
}
